import routes from "@/libs/endPoint/rh/InstrumentoQuestionarioRoutes.js";
import ApiServices from "@/services/uteis/ApiServices.js";
import store from "@/store";
class InstrumentoQuestionarioServices {
  constructor() {
    this.routes = routes;
    this.ApiServices = ApiServices;
  }
  async LoadLista(params = {}) {
    try {
      const url = await this.routes.main;
      const { data } = await this.ApiServices.get(url, params);
      console.log("Lista de instrumentos carregada:", data);
      store.commit("avaliacao/setListaInstrumentos", data);
      return data;
    } catch (error) {
      console.error("Error loading institution list:", error);
      throw error;
    }
  }

  async loadQuestionariosInstrumento(ano, id_instrumento, params = {}) {
    try {
      const url = await this.routes.questionarios(ano, id_instrumento);
      const { data } = await this.ApiServices.get(url, params);
      store.commit("avaliacao/setListaQuestionariosInstrumento", data);
      return data;
    } catch (error) {
      console.error("Error loading questionarios list:", error);
      throw error;
    }
  }
} // fim classe
export default new InstrumentoQuestionarioServices();
